import React, { useMemo } from "react";
import { GetImage } from '../../../../../../components/helpers/GetImage'
import { AiFillEye } from 'react-icons/ai'

const HeaderInfo = ({ data, gadaiID }) => {
  const { commonInfo, headerInfo } = data;
  console.log(headerInfo?.sbgCode)

  return (
    <>
      <div className="d-flex flex-row header-info-left">
        <div>
          <GetImage url={`customer/${commonInfo?.id}/picture`} width={100} height={90} className="picture-style" />
        </div>
        <div className="d-flex flex-column">
          <div className="detail-big-text">
            {headerInfo?.customerName || "-"}
          </div>
          <div className="detail-big-text">ID: {commonInfo?.id || "-"}</div>
          <div className="detail-bold-text">
            {headerInfo?.customerEmail || "-"}
          </div>
          <div className="detail-bold-text">
            {headerInfo?.customerPhone1 || headerInfo?.customerPhone2
              ? `${headerInfo?.customerPhone1} / ${headerInfo?.customerPhone2}`
              : "-"}
          </div>
        </div>
      </div>
      <div className="ml-auto d-flex flex-column align-items-end">
        <div className="detail-big-text" style={{ cursor: "pointer" }} onClick={() => window.open(`/sbg-private/${gadaiID || 0}`, "_blank")}>
          {headerInfo?.sbgCode !== '-' ? < AiFillEye style={{ fontSize: 24, color: "#2C465C", cursor: "pointer" }} /> : null} No. SBG: {headerInfo?.sbgCode || "-"}
        </div>
        <div className="detail-bold-text">
          No. Kwitansi: {headerInfo?.receiptNumber || "-"}
        </div>
        <div className="detail-bold-text">
          Cabang: {headerInfo?.outletName || "-"}
        </div>
        <div className="detail-bold-text">
          Status: <span style={{ color: headerInfo?.status?.color }}>{headerInfo?.status?.label || "-"}</span>
        </div>
        <div className="detail-bold-text">
          Jatuh Tempo: {commonInfo?.dueDate || "-"}
        </div>
      </div>
    </>
  );
};

export default HeaderInfo;
